import * as React from 'react';
import * as styles from './styles.css';
export function Divider() {
  return React.createElement("div", {
    className: styles['divider']
  });
}